import World from "../world";
import Adventure from "./adventure";
import Stage from "./stage";
import Player from "./player";
import { initializeUpdateSchedule } from "./update";

const NOOP = () => null;

class Game {
  static start() {
    return new Game(World.generate());
  }

  constructor(world) {
    this.world = world;
    this.player = Player.create();
    this.adventure = new Adventure(world, this);
    this.stage = new Stage(this.adventure, this.player);
    this.stage.onExitLevel(this.pauseSchedule);
    this.stage.onEnterLevel(this.resetSchedule);
    this.updateSchedule = initializeUpdateSchedule(this.stage);
  }

  pauseSchedule = () => {
    this.updateSchedule = NOOP;
  }

  resetSchedule = () => {
    this.updateSchedule = initializeUpdateSchedule(this.stage);
  }

  update() {
    try {
      const isWaiting = this.updateSchedule();
      this.stage.setWaiting(isWaiting);
    } catch(err) {
      // TODO: race conditions when changing levels
      console.log(err);
    }
  }
}

export default Game;
